/**
 * OrbDocCommunityContributingSLDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCommunityContributingSLDocScreen
 */

import { useOrbDocCommunityContributingSLDocScreenLogic } from '@/hooks/traits/useOrbDocCommunityContributingSLDocScreenLogic';
import type { OrbDocCommunityContributingSLDocScreenConfig } from '@/hooks/traits/useOrbDocCommunityContributingSLDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCommunityContributingSLDocView as OrbDocCommunityContributingSLDocViewEntity } from '@app/shared';
import { OrbDocCommunityContributingSLDocBodyView } from '@/components/traits/OrbDocCommunityContributingSLDocBodyView';
import { OrbDocCommunityContributingSLDocFooterView } from '@/components/traits/OrbDocCommunityContributingSLDocFooterView';
import { OrbDocCommunityContributingSLDocHeaderView } from '@/components/traits/OrbDocCommunityContributingSLDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCommunityContributingSLDocScreenViewProps {
  config?: Partial<OrbDocCommunityContributingSLDocScreenConfig>;
}

export function OrbDocCommunityContributingSLDocScreenView({ config: propsConfig }: OrbDocCommunityContributingSLDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCommunityContributingSLDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCommunityContributingSLDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCommunityContributingSL" trait="OrbDocCommunityContributingSLDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocCommunityContributingSLDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocCommunityContributingSLDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCommunityContributingSLDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCommunityContributingSLDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocCommunityContributingSLDocScreenView;
